
import React, { Component}  from 'react';
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';
import { grey } from "@material-ui/core/colors";

import { FormContext } from 'core/FormProvider';
import {InputNumberWidget, InputSmartNumberWidget} from 'form/InputWidget';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import {AsyncAutocompleteWidget} from "form/AutocompleteWidget";


const StyledFormItem = styled.div`
  display: grid;
  grid-template-columns: 24px 300px 170px 110px 80px 18px;
  grid-gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  
  .index {
    border: 1px solid #333333;
    border-radius: 2px;
    font-weight: bold;
    text-align: center;
    line-height: 24px;
  }
  
  .amount {
    align-items: self-start;
    padding-left: 10px;
    position: relative;
    height: 56px;
    
    .label {
      position: absolute;
      top: -5px;
      font-size: 12px;
      rgba(0, 0, 0, 0.54);
    }
    
    .sum {
      font-size: 16px;
      margin-top: 20px;
    }
  }
`;


export default class ExtraServicesOrderForm extends Component {

  addService = (context) => {
    let extra_services = context.item.extra_services;
    extra_services.push({
      quantity: 1,
      cost: 0,
    });
    context.setValue('extra_services', extra_services)
  };

  removeService = (context, index) => {
    if (index !== -1) {
      let point_service = context.item.extra_services[index];
      if (point_service.id) {
        context.setValue(this.getFieldPath(index, 'is_delete'), true);
      }
      else {
        context.removeArrayValue(`extra_services`, index);
      }
    }
  };

  calculateItemAmount = (context, index) => {
    const extra_service = context.item.extra_services[index];
    return (extra_service.quantity * extra_service.cost).toFixed(2);
  };

  getFieldPath = (index, name) => {
    return `extra_services.${index}.${name}`;
  };

  setServiceValue = (context, name, value, service) => {
    context.setValue(name, value);
  };

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;
          const { extra_services } = item;
          let number = 1;

          return (
            <div className={'mb-15'}>
              <h3>Дополнительные услуги</h3>

              {extra_services.map((extra_service, index) =>
                <React.Fragment key={index}>
                  {!extra_service.is_delete && (
                    <StyledFormItem>
                      <div className={'index'}>{number++}</div>
                      <div>
                        <ContextFormControlWidget
                          name={this.getFieldPath(index, 'service')}
                          WidgetComponent={AsyncAutocompleteWidget}
                          widgetProps={{
                            label: 'Услуга',
                            url: 'catalog/service',
                            optionLabel: 'name',
                            filter: {
                              type: 'ORDER',
                              is_active: true
                            },
                            onChange: (value, service) => this.setServiceValue(context, this.getFieldPath(index, 'service'), value, service),
                            autocompleteProps: {
                              renderOption: (option) => <span>{option['name']} <small style={{color: grey[500]}}>{option['financial_schema_display']}</small></span>,
                              getOptionLabel: (option) => `${option['name']} (${option['financial_schema_display']})`
                            }
                          }}
                        />
                      </div>

                      <div>
                        <ContextWidget
                          name={this.getFieldPath(index, 'cost')}
                          WidgetComponent={InputNumberWidget}
                          widgetProps={{
                            label: 'Цена, ₽',
                            required: true,
                            InputLabelProps: {
                              shrink: true
                            }
                          }}
                        />
                      </div>

                      <div>
                        <ContextWidget
                          name={this.getFieldPath(index, 'quantity')}
                          WidgetComponent={InputSmartNumberWidget}
                          widgetProps={{
                            label: 'Количество',
                            required: true
                          }}
                        />
                      </div>

                      <div className={'amount'}>
                        <div className={'label'}>Итого</div>
                        <div className={'sum'}>{this.calculateItemAmount(context, index)}₽</div>
                      </div>

                      <div>
                        <IconButton onClick={() => this.removeService(context, index)}>
                          <ClearIcon size={'small'} />
                        </IconButton>
                      </div>

                    </StyledFormItem>
                  )}
                </React.Fragment>
              )}

              <div style={{marginLeft: '34px'}}>
                <Button
                  variant="outlined"
                  onClick={() => this.addService(context)}
                >
                  + Добавить услугу
                </Button>
              </div>
            </div>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
